webpackJsonp([247],{

/***/ 1209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionDetail_vue__ = __webpack_require__(2921);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e929fdf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionDetail_vue__ = __webpack_require__(5219);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e929fdf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 2921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.params.id,
      // searchRules,
      form: {
        up_date: null,
        down_date: null,
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        status: null,
        province_name: null,
        city_name: null,
        area_name: null
      },
      options: {
        industry_type: [],
        position_type: [],
        salary: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: []
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    var _this = this;

    request.all.page([request('getPostionForm', this.id), request('editPostionOptions')]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          postionForm = _ref2[0],
          postionOptions = _ref2[1];

      (function (data) {
        filter.setLoop(_this.form, data.data);
      })(postionForm);(function (data) {
        filter.setLoop(_this.options, data.data);
      })(postionOptions);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPostionForm', 'editPostionOptions']))
});

/***/ }),

/***/ 5219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("招聘管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/position/detail/'+_vm.id}}},[_vm._v("职位列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px","size":"mini"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("基本信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"release_time","label":"发布时间:"}},[_vm._v("\n          "+_vm._s(_vm.form.up_date)+"~"+_vm._s(_vm.form.down_date)+"\n        ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"行业大类:"}},_vm._l((_vm.options.industry_type),function(industryType){return (industryType.id === _vm.form.industry_type)?_c('span',[_vm._v("\n            "+_vm._s(industryType.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"职位类型:"}},_vm._l((_vm.options.position_type),function(positionType){return (positionType.id === _vm.form.position_type)?_c('span',[_vm._v("\n            "+_vm._s(positionType.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位名称:"}},[_vm._v(_vm._s(_vm.form.title))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"招聘人数:"}},[_vm._v(_vm._s(_vm.form.hire_number))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作地点:"}},[_vm._v(_vm._s(_vm.form.province_name)+"-"+_vm._s(_vm.form.city_name)+"-"+_vm._s(_vm.form.area_name)+"       \n          "+_vm._s(_vm.form.address)+"\n        ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发布单位:"}},[_vm._v(_vm._s(_vm.form.employer_name))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("职位描述")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作时间:"}},[_vm._v(_vm._s(_vm.form.position_period))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作班次:"}},[_vm._v(_vm._s(_vm.form.working_shifts))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作时长:"}},[_vm._v(_vm._s(_vm.form.working_hours))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"性别要求:"}},_vm._l((_vm.options.gender),function(gender){return (gender.id === _vm.form.gender)?_c('span',[_vm._v("\n            "+_vm._s(gender.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"年龄要求:"}},[_vm._v(_vm._s(_vm.form.age_range))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"证件要求:"}},[_vm._v(_vm._s(_vm.form.certificate))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"学历要求:"}},_vm._l((_vm.options.education),function(education){return (education.id === _vm.form.education)?_c('span',[_vm._v("\n            "+_vm._s(education.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"婚姻状况:"}},_vm._l((_vm.options.marriage),function(marriage){return (marriage.id === _vm.form.marriage)?_c('span',[_vm._v("\n            "+_vm._s(marriage.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作经验:"}},[_vm._v(_vm._s(_vm.form.working_experience))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"补充说明:"}},[_vm._v(_vm._s(_vm.form.other_requirements))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("薪资福利")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"基本薪资:"}},[_vm._l((_vm.options.salary),function(salary){return (salary.id === _vm.form.salary)?_c('span',[_vm._v(_vm._s(salary.keyword))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.options.salary_type),function(salaryType){return (salaryType.id === _vm.form.salary_type)?_c('span',[_vm._v("\n            "+_vm._s(salaryType.keyword)+"\n          ")]):_vm._e()})],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提成机制:"}},[_vm._v(_vm._s(_vm.form.commission))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"季度奖金:"}},[_vm._v(_vm._s(_vm.form.quarterly_bonus))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"社保缴纳:"}},_vm._l((_vm.options.insurance),function(insurance){return (insurance.id === _vm.form.insurance)?_c('span',[_vm._v("\n            "+_vm._s(insurance.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加班补助:"}},[_vm._v(_vm._s(_vm.form.overtime_pay))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"餐饮补助:"}},[_vm._v(_vm._s(_vm.form.meal_allowance))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"交通补助:"}},[_vm._v(_vm._s(_vm.form.commute_allowance))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"话费补助:"}},[_vm._v(_vm._s(_vm.form.phone_allowance))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"其他福利:"}},[_vm._v(_vm._s(_vm.form.welfare))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结算方式:"}},_vm._l((_vm.options.settlement_type),function(settlementType){return (settlementType.id === _vm.form.settlement_type)?_c('span',[_vm._v("\n            "+_vm._s(settlementType.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结算时间:"}},_vm._l((_vm.options.settlement_time),function(settlementTime){return (settlementTime.id === _vm.form.settlement_time)?_c('span',[_vm._v("\n            "+_vm._s(settlementTime.keyword)+"\n          ")]):_vm._e()}),0)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"text-align":"center"}},[_c('Br'),_vm._v(" "),(_vm.form.status === 0 || _vm.form.status === 2)?_c('router-link',{attrs:{"to":{ path: '/position/update/'+_vm.id}}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("修改")])],1):_vm._e(),_vm._v("\n          \n      "),_c('router-link',{attrs:{"to":{ path: '/position/table'}}},[_c('el-button',[_vm._v("返回")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/247.f49cff8cb7f1bd6d5380.js